import { render } from "./AppPackDialog.vue?vue&type=template&id=8c1c1726&scoped=true"
import script from "./AppPackDialog.vue?vue&type=script&lang=js"
export * from "./AppPackDialog.vue?vue&type=script&lang=js"

import "./AppPackDialog.vue?vue&type=style&index=0&id=8c1c1726&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1c1726"]])

export default __exports__